import { assertNever } from './assertNever'

export function openProfile(accountType: 'parent' | 'sitter', token: string) {
  window.open(
    window.location.protocol +
      '//' +
      window.location.host +
      (accountType === 'parent' ? '/p/' : accountType === 'sitter' ? '/s/' : assertNever(accountType)) +
      token
  )
}
